module.exports = __webpack_public_path__ + "static/media/sygnet.d3328538.svg";